import { ICON__download_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_hint_shortcut } from '@/hooks/hints_shortcut/use_hint_shortcut';
import { HOOK_IMAGE__download } from '@/hooks/image/HOOK_IMAGE__download';
import { use_slice_user } from '@/hooks/store/use_slices';
import { HOOK_GRID2D_CELL__button_size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__button_size';
import { EVENT_NULL__mouse } from '@/types/types';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { ENUM__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { ViewShortcutTrigger } from '../../shortcut_hint/ViewShortcutTrigger';

interface Props {
  image: DTO__image_asset;
  wrapper_class_name: string;
}

export function BUTTON_GRID2D_IMAGE__download({ image, wrapper_class_name }: Props) {
  const { user_settings } = use_slice_user(['user_settings']);

  const grid2d_cell_button_size = HOOK_GRID2D_CELL__button_size(user_settings.ui_grid2d_cell_size);

  const { on_user_uses_component } = use_hint_shortcut(EShortcutType.GRID2D_CELL_BUTTON_COPY_TO_CLIPBOARD);

  const { download_image } = HOOK_IMAGE__download();
  /*
   * EVENTS
   */

  async function onClick(e: EVENT_NULL__mouse) {
    e?.stopPropagation();

    on_user_uses_component();

    download_image(image);
  }

  /*
   * RENDERS
   */

  function render_button() {
    /*
     * HTML
     */

    return (
      <ViewShortcutTrigger hint_shortcut_keys={[EShortcutType.GRID2D_CELL_BUTTON_COPY_TO_CLIPBOARD]}>
        <div className={wrapper_class_name}>
          <UI_PRIMITIVE__button_with_icon_animated
            Icon={ICON__download_solid}
            iconClassNameHovered="!text-bar-foreground"
            iconClassNameBase={`!text-component-item-foreground !duration-300 !w-5 !h-5
            ${user_settings.ui_grid2d_cell_size === ENUM__grid2d_cell_size.L ? '!size-7' : ''}`}
            variant="no-border-on-component"
            size="square-10"
            onClick={onClick}
            className={`cursor-pointer rounded-lg p-0 bg-bar
            ${grid2d_cell_button_size}`}
          />
        </div>
      </ViewShortcutTrigger>
    );
  }

  return render_button();
}
